import { getAccessibleHubAppIds, type HubAppId } from '@apexx/shell-contract';

export interface DualPaneRailApp {
	id: string;
	label: string;
	/** Icon name from `@apexx/component-library` Icon. */
	icon: string;
	active?: boolean;
}

/**
 * Hub apps shown in the DualPane primary rail.
 * Labels/icons align with hub `APP_REGISTRY` / launcher tiles.
 */
export const DEFAULT_HUB_RAIL_APPS: Omit<DualPaneRailApp, 'active'>[] = [
	{ id: 'machines', label: 'Customer Support', icon: 'precision_manufacturing' },
	{ id: 'quality', label: 'Inspection', icon: 'checklist' },
	{ id: 'chat', label: 'Team Chat', icon: 'comments' },
	{ id: 'documents', label: 'Documents', icon: 'folder' },
	{ id: 'tasks', label: 'Tasks', icon: 'todo' },
	{ id: 'training', label: 'Training', icon: 'cap' },
];

/**
 * Builds rail apps the token may launch (same filter as hub launcher via
 * {@link getAccessibleHubAppIds}), with `active` set for the current hub app.
 */
export function buildHubRailApps(activeAppId: string, accessToken?: string): DualPaneRailApp[] {
	const accessibleIds = new Set<HubAppId>(getAccessibleHubAppIds(accessToken));

	return DEFAULT_HUB_RAIL_APPS.filter((app) => accessibleIds.has(app.id as HubAppId)).map(
		(app) => ({
			...app,
			active: app.id === activeAppId,
		}),
	);
}
